import { createIcon } from "@chakra-ui/react";

export const Funnel = createIcon({
  displayName: "Funnel",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2.714C3 2.32 3.32 2 3.714 2h17.143c.395 0 .714.32.714.714v2.857a.714.714 0 0 1-.183.478l-6.245 6.94v6.868c0 .308-.197.58-.489.678l-4.285 1.428a.714.714 0 0 1-.94-.677v-8.298L3.183 6.05A.714.714 0 0 1 3 5.571V2.714zm1.429.715v1.868l6.245 6.94a.714.714 0 0 1 .183.477v7.58l2.857-.952v-6.628c0-.176.066-.346.184-.478l6.245-6.939V3.43H4.429z"
    />,
  ],
  defaultProps: {
    "aria-label": "A funnel icon"
  }
});

export default Funnel;
